const COOKIE_SCRIPT_KEY = 'CookieScriptConsent' as const

export const getCookieConsentByCategory = (category: string): boolean => {
  const cookie = useCookie<any>(COOKIE_SCRIPT_KEY)
  let cookieIsAllowed: boolean

  if (cookie.value && cookie.value?.categories) {
    const categories = JSON.parse(cookie.value?.categories)
    cookieIsAllowed = categories.includes(category)
  } else {
    cookieIsAllowed = false
  }

  return cookieIsAllowed
}
